import React from "react";
import { toastr } from "react-redux-toastr";
import Modal from "../../commonComponents/util/Modal";
import Select from "../../commonComponents/util/Select";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";



function getReportFields() {
  return [
    { label: "Title", value: "Title", default: "" },
    { label: "Last Name/Org Name", value: "LastOrOrgName", default: "" },
    { label: "First Name", value: "FirstName", default: "" },
    { label: "Report Name", value: "ReportName", default: "" },
    { label: "Address", value: "Address", default: "" },
    { label: "Unit #", value: "UnitNumber", default: "" },
    { label: "City", value: "City", default: "" },
    { label: "State", value: "State", default: "" },
    { label: "Zip", value: "Zip", default: "" },
    { label: "Country", value: "Country", default: "" },
    { label: "Phone Number(s)", value: "PhoneNumbers", default: "" },
    { label: "Reference(s)", value: "References", default: "" },
    { label: "Solicitor(s)", value: "Solicitors", default: "" },
    { label: "Rosh Yeshiva(s)", value: "RoshYeshivas", default: "" },
    { label: "Status", value: "Status", default: "" },
    { label: "Amount", value: "Amount", default: "" },
    { label: "Currency", value: "Currency", default: "" },
    { label: "Fund", value: "Fund", default: "" },
    { label: "Reason", value: "Reason", default: "" },
    { label: "Check Date", value: "CheckOrWireDate", default: "" },
    { label: "Check #", value: "CheckOrWireNumber", default: "" },
    { label: "Campaign", value: "Campaign", default: "" },
    { label: "Campaign List", value: "CampaignList", default: "" },
    { label: "Campaign List Contact", value: "CampaignListContact", default: "" },
    { label: "Campaign Indiv Category", value: "CampaignIndivCat", default: "" },
    { label: "Created Date", value: "CreatedDate", default: "" },
    { label: "Review Date", value: "ReviewByDate", default: "" },
    { label: "Teudat Zehut", value: "TeudatZahut", default: "" },
    { label: "Source", value: "Source", default: "" },
    { label: "Approver", value: "Approver", default: "" },
    { label: "Notes", value: "Notes", default: "" },
    { label: "Check Memo", value: "CheckMemo", default: "" },
    { label: "Report Memo", value: "ReportMemo", default: "" },
  ];
}

const initialState = {
  fields: [],
  groupBy: "",
  sortBy: "",
  sortDirection: "",
  error: false,
  noData: false,
  downloading: false,
  submitAttempted: false
};

const modalCloseAnimationMs = 300;

const sortDirectionOptions = [
  { key: "Ascending", value: "Ascending" },
  { key: "Descending", value: "Descending" },
];

export default class ApplicationsReportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      clearTimeout(this.closeTimeout);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.closeTimeout);
  }

  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onChangeSortBy = (name, value) => {
    this.onChange(name, value);

    if (value === "") {
      this.setState({ sortDirection: "" });
    }
    else if (this.state.sortDirection === "") {
      this.setState({ sortDirection: sortDirectionOptions[0].value });
    }
  };

  onToggleReportFields = event => {
    const fieldName = event.target.name;
    const checked = event.target.checked;

    let fields = [...this.state.fields];
    if (checked) {
      fields.push(fieldName);
    } else {
      fields = fields.filter(f => f !== fieldName);

      if (this.state.groupBy === fieldName) {
        this.setState({ groupBy: "" });
      }

      if (this.state.sortBy === fieldName) {
        this.setState({ sortBy: "" });
      }
    }

    this.setState({ fields });
  };

  close() {
    this.props.close();
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => {
      this.setState(initialState);
    }, modalCloseAnimationMs);
  }

  async exportData() {
    this.setState({
      error: false,
      noData: false,
      submitAttempted: true
    });

    const { fields, groupBy, sortBy, sortDirection } = this.state;

    if (!fields.length) {
      return;
    }

    try {
      const now = new Date();
      const dateStamp = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0')
      ].join('') + '_' + [
        String(now.getHours()).padStart(2, '0'),
        String(now.getMinutes()).padStart(2, '0'),
        String(now.getSeconds()).padStart(2, '0')
      ].join('');
      const fileName = `Applications_Report_${dateStamp}.xlsx`;

      let params = {
        fields,
        groupBy,
        sortBy,
        sortDirection
      };

      this.setState({ downloading: true });

      const response = await this.props.getDataForExport(params);

      if (!response.success) throw Error(response.noData ? "noData" : "error");

      const blob = response.data instanceof Blob
        ? response.data
        : new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1000);

      toastr.success("Your report is ready");
      this.setState({ downloading: false }, this.close);
    } catch (error) {
      this.setState({ downloading: false, [error.message || "error"]: true });
    }
  }

  render() {
    const {
      error,
      fields,
      groupBy,
      sortBy,
      sortDirection,
      downloading,
      noData,
      submitAttempted
    } = this.state;

    const {
      show
    } = this.props;

    const reportFields = getReportFields();

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal new-fund-modal large-modal">
            <div className="bordered-modal-header">
              <h4 className="modal-page-header">
                Applications Report
              </h4>
              <i
                className={`icon ion-ios-close-empty ${downloading ? "disabled" : ""}`}
                onClick={downloading ? null : this.close.bind(this)}
              />
            </div>
            <div className="modal-section">
              <div className="mb-16">
                <div className="flex">
                  <label
                    className={`input-label ${
                      submitAttempted && !fields.length ? "error-label" : ""
                      }`}
                  >
                    Report Fields
                  </label>
                  {submitAttempted && !fields.length && (
                    <span className="xs-text error-text ml-8">
                      * Please select report fields
                    </span>
                  )}
                </div>
                <div className="modal-row report-fields-grid">
                  {reportFields.map(field => (
                    <div className="custom-check-container" key={field.value}>
                      <input
                        type="checkbox"
                        id={`report-field-${field.value}`}
                        className="custom-check"
                        name={field.value}
                        onChange={this.onToggleReportFields}
                        checked={fields.indexOf(field.value) >= 0}
                        disabled={downloading}
                      />
                      <label
                        htmlFor={`report-field-${field.value}`}
                        className="secondary-text"
                      >
                        {field.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-row">
                <div className="column-half column-half-left">
                  <label className="input-label">
                    Remove Duplicates Of
                  </label>
                  <Select
                    clearable={!downloading}
                    options={reportFields
                      .filter(field => fields.indexOf(field.value) >= 0)
                      .map(field => ({
                        key: field.value,
                        value: field.label
                      }))}
                    value={groupBy}
                    name="groupBy"
                    disabled={downloading}
                    onChange={e =>
                      this.onChange(e.target.name, e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="modal-row">
                <div className="column-half column-half-left">
                  <label className="input-label">
                    Sort By
                  </label>
                  <Select
                    clearable={!downloading}
                    options={reportFields
                      .filter(field => fields.indexOf(field.value) >= 0)
                      .map(field => ({
                        key: field.value,
                        value: field.label
                      }))}
                    value={sortBy}
                    name="sortBy"
                    disabled={downloading}
                    onChange={e =>
                      this.onChangeSortBy(e.target.name, e.target.value)
                    }
                  />
                </div>
                <div className="column-half column-half-left">
                  <label className="input-label">
                    Sort Direction
                  </label>
                  <Select
                    options={sortDirectionOptions}
                    disabled={downloading || sortBy === ""}
                    value={sortDirection}
                    name="sortDirection"
                    onChange={e =>
                      this.onChange(e.target.name, e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            
            <div className="modal-btns text-right">
              {downloading && (
                <div className="small-text info-text mb-8">
                  Generating report... This may take a minute.
                </div>
              )}
              <button
                className="btn btn-accent"
                onClick={this.close.bind(this)}
                disabled={downloading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.exportData.bind(this)}
                disabled={downloading}
              >
                {downloading ? "Generating Report" : "Download Report"}
              </button>
              <FadeOutErrorMessage show={error} />
              <FadeOutErrorMessage
                show={noData}
                message="No data was found."
                timeOut={5000}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applications/ApplicationsReportModal.jsx